// src/components/Sidebar.tsx
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  FaTachometerAlt,
  FaBoxOpen,
  FaFileInvoice,
  FaUser,
  FaSignOutAlt,
  FaHistory,
  FaWarehouse,
  FaChartBar
} from "react-icons/fa";

// Explicitly type the icons
const DashboardIcon = FaTachometerAlt as React.ElementType;
const ProductsIcon = FaBoxOpen as React.ElementType;
const InvoiceIcon = FaFileInvoice as React.ElementType;
const UserIcon = FaUser as React.ElementType;
const LogoutIcon = FaSignOutAlt as React.ElementType;
const HistoryIcon = FaHistory as React.ElementType;
const WarehouseIcon = FaWarehouse as React.ElementType;
const StockIcon = FaChartBar as React.ElementType;
const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="w-64 bg-gray-900 text-white min-h-screen p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Mangrish</h1>
        <p className="text-sm text-gray-300 mt-1">
          {user?.role.toUpperCase()} Panel
        </p>
      </div>

      <nav className="space-y-3">
        <Link
          className="flex items-center gap-2 hover:underline"
          to="/dashboard"
        >
          <DashboardIcon /> Dashboard
        </Link>
        <Link
          className="flex items-center gap-2 hover:underline"
          to="/products"
        >
          <ProductsIcon /> Products
        </Link>
        <Link
          className="flex items-center gap-2 hover:underline"
          to="/quotation/new"
        >
          <InvoiceIcon /> New Quotation
        </Link>
        <Link
          className="flex items-center gap-2 hover:underline"
          to="/quotation/history"
        >
          <InvoiceIcon /> Quotation History
        </Link>
        <Link
          className="flex items-center gap-2 hover:underline"
          to="/proforma-invoices"
        >
          <HistoryIcon /> PI History
        </Link>
        <Link
          className="flex items-center gap-2 hover:underline"
          to="/stock-display"
        >
          <StockIcon /> Stock Display
        </Link>
        {(user?.role === "admin" || user?.role === "manager") && (
          <>
            <Link className="flex items-center gap-2 hover:underline" to="/inventory">
              <WarehouseIcon /> Inventory Management
            </Link>
            <Link className="flex items-center gap-2 hover:underline" to="/staff">
              <UserIcon /> Staff Management
            </Link>
          </>
        )}
      </nav>

      <button
        onClick={handleLogout}
        className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded w-full mt-10"
      >
        <LogoutIcon /> Logout
      </button>
    </div>
  );
};

export default Sidebar;